import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'ase.recurrentProblem.title',
        defaultMessage: 'Recurrent Problems'
    },
    EMPTY: {
        id: 'ase.recurrentProblem.empty',
        defaultMessage: 'There is no recurrent problem defined'
    },
    TABLE_PROBLEM_NUMBER: {
        id: 'ase.recurrentProblem.table.problemNumber',
        defaultMessage: 'Problem number'
    },
    TABLE_PROBLEM_TITLE: {
        id: 'ase.recurrentProblem.table.problemTitle',
        defaultMessage: 'Problem title'
    },
    TABLE_ATTACHMENT: {
        id: 'ase.recurrentProblem.table.attachment',
        defaultMessage: 'Attachment'
    },
    TABLE_LAST_UPDATE: {
        id: 'ase.recurrentProblem.table.lastUpdate',
        defaultMessage: 'Last update'
    },
    SELECT_COUNTRY: {
        id: 'ase.recurrentProblem.selectCountry',
        defaultMessage: 'Select a country'
    },
});

export default messages;
